import React from "react";
import { Formik } from "formik";
import { Col, Form, Row } from "react-bootstrap";
import { CustomSelect, GradeOptions, ParentOptions, StudentSexOptions } from "../../../../../../_helpers/Helpers";

export function UnregisteredStudentEditForm({  
  unregisteredStudent,
  btnRef,
  saveUnregisteredStudent
}) {
  return (
    <Formik
      enableReinitialize={true}
      initialValues={unregisteredStudent}
      onSubmit={(values) => {
        if (values.birthDate === "") values.birthDate = null;
        saveUnregisteredStudent(values);
      }}
    >
      {({ handleSubmit, handleChange, setFieldValue, values }) => (
        <Form onSubmit={(e) => {
          e.preventDefault();
          handleSubmit();
        }}>
          <div className="row">
            <div className="col-6">  
              <Form.Group as={Row}>
                <Form.Label column sm={4}>
                  Dönem<span> *</span>
                </Form.Label>
                <Col sm={4}>
                  <Form.Control
                    type="number" 
                    min={0}
                    value={values.term}
                    id="term" 
                    placeholder="Dönem"
                    onChange={e => {
                      handleChange(e)
                      handleChange("term2")(e);
                    }}
                  />
                </Col>
                <Col sm={4}>
                  <Form.Control value={values.term + 1} id="term2" readOnly />
                </Col>
              </Form.Group>
          
              <Form.Group as={Row} controlId="tcKimlikNo">
                <Form.Label column sm={4}>
                  TC Kimlik No<span> *</span>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="text" value={values.tcKimlikNo} placeholder="TC Kimlik No" onChange={handleChange} />
                </Col>
              </Form.Group>
                                  
              <Form.Group as={Row} controlId="name">
                <Form.Label column sm={4}>
                  Adı<span> *</span>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="text" value={values.name} placeholder="Adı" onChange={handleChange} />
                </Col>
              </Form.Group>
          
              <Form.Group as={Row} controlId="surname">
                <Form.Label column sm={4}>
                  Soyadı<span> *</span>
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="text" value={values.surname} placeholder="Soyadı" onChange={handleChange} />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="sex">
                <Form.Label column sm={4}>
                  Cinsiyeti <span>*</span>
                </Form.Label>
                <Col sm={8}>
                  <CustomSelect 
                    options={StudentSexOptions}
                    value={values.sex}
                    onChange={option => setFieldValue("sex", option.value)}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="birthDate">
                <Form.Label column sm={4}>
                  Doğum Tarihi
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="date" value={values.birthDate} placeholder="Doğum Tarihi" onChange={handleChange} />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="grade">
                <Form.Label column sm={4}>
                  Sınıfı <span>*</span>
                </Form.Label>
                <Col sm={8}>
                  <CustomSelect 
                    options={GradeOptions}
                    value={values.grade}
                    onChange={option => setFieldValue("grade", option.value)}
                  />
                </Col>
              </Form.Group>
            </div>
          
            <div className="col-6">
              <Form.Group as={Row} controlId="school">
                <Form.Label column sm={4}>
                  Okulu
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="text" value={values.school} placeholder="Okulu" onChange={handleChange} />
                </Col>
              </Form.Group>
                                  
              <Form.Group as={Row} controlId="parentName">
                <Form.Label column sm={4}>
                  Veli Adı
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="text" value={values.parentName} placeholder="Veli Adı" onChange={handleChange} />
                </Col>
              </Form.Group>
          
              <Form.Group as={Row} controlId="parentSurname">
                <Form.Label column sm={4}>
                  Veli Soyadı
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="text" value={values.parentSurname} placeholder="Veli Soyadı" onChange={handleChange} />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="parentPhone">
                <Form.Label column sm={4}>
                  Veli Telefonu
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="text" value={values.parentPhone} placeholder="Veli Telefonu" onChange={handleChange} />
                </Col>
              </Form.Group>
          
              <Form.Group as={Row} controlId="parentEmail">
                <Form.Label column sm={4}>
                  Veli Maili
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="text" value={values.parentEmail} placeholder="Veli Maili" onChange={handleChange} />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="relationship">
                <Form.Label column sm={4}>
                  Veli Yakınlığı
                </Form.Label>
                <Col sm={8}>
                  <CustomSelect 
                    options={ParentOptions}
                    value={values.relationship}
                    onChange={option => setFieldValue("relationship", option.value)}
                  />
                </Col>
              </Form.Group>

              <Form.Group as={Row} controlId="address">
                <Form.Label column sm={4}>
                  Adresi
                </Form.Label>
                <Col sm={8}>
                  <Form.Control type="text" value={values.address} placeholder="Adresi" onChange={handleChange} />
                </Col>
              </Form.Group>
            </div>
          </div>

          <Form.Group as={Row} controlId="explanation">
            <Form.Label column sm={2}>
              Açıklama
            </Form.Label>
            <Col sm={10}>
              <Form.Control 
                as="textarea"
                rows="2"
                placeholder="Açıklama"
                value={values.explanation}
                onChange={handleChange}
              />
            </Col>
          </Form.Group>
          
          <button
            type="submit"
            style={{ display: "none" }}
            ref={btnRef}
          ></button>
        </Form>
      )}      
    </Formik>
  );
}